import React, { useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import { useLocation } from 'react-router-dom';

const NavLinks = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    // const getLinkStyle = (path) => {
    //     return location.pathname === path
    //         ? 'px-4 font-extrabold text-yellow-600 border-b-2 border-yellow-600 w-min mx-auto transition duration-300'
    //         : 'px-4 font-extrabold text-gray-100 hover:text-yellow-600 hover:border-b-2 hover:border-yellow-600 w-min mx-auto transition duration-300';
    // };

    const getLinkStyle = (path) => {
        const baseStyle =
            'font-extrabold transition duration-300 inline-block mx-auto'; // inline-block keeps underline to text width

        return location.pathname === path
            ? `${baseStyle} text-yellow-600 border-b-2 border-yellow-600`
            : `${baseStyle} text-gray-400 hover:text-yellow-600 hover:border-b-2 hover:border-yellow-600`;
    };


    return (
        <>
            <HashLink className={getLinkStyle('/')} to="/">
                Home
            </HashLink>
            <HashLink className={getLinkStyle('/about')} smooth to="/about">
                About
            </HashLink>
            <HashLink className={getLinkStyle('/services')} smooth to="/services">
                Services
            </HashLink>
            <HashLink className={getLinkStyle('/blogs')} smooth to="/blogs">
                Blog
            </HashLink>
            <HashLink className={getLinkStyle('/careers')} smooth to="/careers">
                Careers
            </HashLink>
            <HashLink className={getLinkStyle('/contact')} to="/contact">
                Contact Us
            </HashLink>
            <HashLink className="text-white bg-gray-600 hover:bg-gray-800 inline-flex items-center justify-center w-auto px-6 py-2 shadow-xl rounded-xl" smooth to="/get-demo#demo">
                Demo our products
            </HashLink>
        </>
    );
};

export default NavLinks;
